import { useAuthState, useRole } from "@src/hooks/useAuth";
import { device } from "@src/theme";
import React from "react";
import styled from "styled-components";
import Tooltip from "../Tooltip";
import { currentVersion } from "@src/appVersionConfigs";

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props): string => props.theme.margins.small};
  height: 51px;
`;
const HelloText = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${(props): string => props.theme.colors.black};
  @media ${device.mobile} {
    display: none;
  }
  @media ${device.tablet} {
    display: none;
  }
`;

const UserName = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${(props): string => props.theme.colors.black};

  @media ${device.mobile} {
    display: none;
  }

  @media ${device.tablet} {
    display: none;
  }

  @media ${device.laptop} {
    display: block;
  }

  @media ${device.desktop} {
    display: block;
  }

  @media ${device.desktopXL} {
    display: block;
  }
`;

const ROLE_DISPLAY_NAMES: Record<string, string> = {
  admin: "Admin",
  manager: "Manager",
};

const GreetingText = (): React.JSX.Element => {
  const { curator } = useAuthState();
  const roleType = useRole();
  const displayName = ROLE_DISPLAY_NAMES[roleType] || curator?.name;
  const showTooltip = roleType === "admin" || roleType === "manager";

  return (
    <ItemContainer>
      <HelloText>Hello,</HelloText>
      <UserName>
        {showTooltip ? (
          <Tooltip style={{ display: "flex" }} content={currentVersion.version}>
            {displayName}
          </Tooltip>
        ) : (
          displayName
        )}
      </UserName>
    </ItemContainer>
  );
};

export default GreetingText;
